import request from '@/utils/request'
const apiPath = '/sys/homeFunctionArea'
import { downloadBlob } from '@/utils/download'
const functionTypesApi = {
  /**
   * 新增【功能类型】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【功能类型】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【功能类型】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查询【功能类型】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【功能类型】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【功能类型】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
}
export default functionTypesApi
